// extracted by mini-css-extract-plugin
module.exports = {"SNA15":"SNA15_SNA15__GRw8S","Controls":"SNA15_Controls__1LWHX","InputPanels":"SNA15_InputPanels__1AR3K"};